import React, { useRef, useState, useEffect, useContext } from 'react';

import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../context/auth-context';
import Button from '../Button/Button';
import './ImageUpload.css';
import ErrorModal from '../../UIElements/ErrorModal';
import LoadingSpinner from '../../UIElements/LoadingSpinner';
import videoConference from '../../../../videoConferencePic.png';

const ImageUpload = props => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [file, setFile] = useState();
  const [isValid, setIsValid] = useState(false);
  const [filePath, setFilePath] = useState();

  const filePickerRef = useRef();

  useEffect(()=>{
    if (props.filepath) {
      setFilePath(props.filepath);
    }
  },[props.filepath]);

  useEffect(() => {
    if (!file) {
      return;
    }
    const fetchThumnail = async() => {
    try {
      const formData = new FormData();
      formData.append("title", "video uploaded")
      formData.append("video", file);
      const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/upload/${props.questionId}`, 'POST', formData, {Authorization: 'Bearer '+ auth.token});
      setFilePath(responseData.filepath);
      props.onPick(responseData.filepath);
    } catch (err) {
        
    }
    };
    fetchThumnail();
  }, [file, sendRequest, auth.token]);

  const pickedHandler = event => {
    let pickedFile;
    let fileIsValid = isValid;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setFile(pickedFile);
      setIsValid(true);
      fileIsValid = true;
    } else {
      setIsValid(false);
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  const pickImageHandler = () => {
    filePickerRef.current.click();
  };

  return (
    <React.Fragment>
    {<ErrorModal error={error} onClear={clearError} />}
    {isLoading && <LoadingSpinner asOverlay />}
    <div className="form-control">
      <input
        id={props.id}
        ref={filePickerRef}
        style={{ display: 'none' }}
        type="file"
        accept=".mp4"
        onChange={pickedHandler}
      />
      <div className={`image-upload ${props.center && 'center'}`}>
        <div className="image-upload__preview">
          {!filePath && <div className="image-upload-preview-novideo"><img src={videoConference} alt="" className='videoConference'/><p>Please upload or record a video</p></div>}
          {filePath && <video src={`${filePath}`} controls className='video'/>}
        </div>
        <Button type="button" onClick={pickImageHandler}>
          UPLOAD VIDEO
        </Button>
      </div>
      {!isValid && <p>{props.errorText}</p>}
    </div>
    </React.Fragment>
  );
};

export default ImageUpload;